const model = {
  ROLE_USER: 1,
  ROLE_MANAGER: 30,
  ROLE_ADMIN: 100,
};

export default model;
